import React from "react"
import { Block, Spacer } from "../../atoms/layout-primitives"
import { BlogGrid } from "../../atoms/layout-primitives/grid"
import { IArticle } from "../../molecules/article-card"
import ArticleCardGrid from "../../organisms/article-card-grid"
import { IContentfulComposePage } from "../../types/blog.types"
import { contentfulBlogPostToArticleCard } from "../../util/contentful-data"

interface IListingArticles {
  articles: { node: IContentfulComposePage }[]
}

/**
 * Template for articles listing
 * @param articles - contentful articles to display
 */
const ListingArticles = ({ articles }: IListingArticles) => {
  const articleCardsData: IArticle[] =
    articles &&
    articles.map(({ node: article }) =>
      contentfulBlogPostToArticleCard(article)
    )
  return (
    <BlogGrid>
      <Block>
        <ArticleCardGrid articles={articleCardsData} overflow="new-line" />
        <Spacer height={{ sm: "48px" }} />
      </Block>
    </BlogGrid>
  )
}

export default ListingArticles
